module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.images) ? _c('div', {
    ref: "container",
    staticClass: "interactive-image",
    attrs: {
      "data-grayscale": _vm.grayscale
    },
    on: {
      "mousemove": _vm.onMousemove,
      "touchmove": _vm.onTouchmove,
      "touchend": function($event) {
        _vm.grayscale = true
      },
      "touchstart": function($event) {
        _vm.grayscale = false
      }
    }
  }, [(_vm.loadImgs) ? _vm._l((_vm.images), function(image) {
    return _c('img', {
      attrs: {
        "src": image.src,
        "data-visible": image.visible,
        "alt": _vm.alt
      }
    })
  }) : _c('img', {
    attrs: {
      "src": _vm.mobileImgSrc,
      "data-visible": ""
    }
  })], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c854736"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/InteractiveImage.vue
// module id = 385
// module chunks = 1